import React, { useContext, useEffect, useMemo, useState } from 'react';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home';
import QuizScreen from './components/QuizScreen';
import CourseQuizScreen from './components/courses/CourseQuizScreen';
import QuizScreen1 from './components/QuizScreen1';
import EditNewQuestions1 from './components/EditNewQuestions1';
import EventMainScreen from './components/EventMainScreen';
import TexttoSpeech from './components/TexttoSpeech';
import EditBatch from './components/Class/EditBatch';
import Dashboard from './components/assignments/Dashboard';
import PracticeCatScreen from './components/practice/PracticeCatScreen';
import PracticeScreen from './components/practice/PracticeScreen';
import PracticeQuiz from './components/practice/PracticeQuiz';
import SubCategorySelection from './components/practice/SubCategorySelection';
import DailyReviewScreen from './components/practice/DailyReviewScreen';
import Settings from './components/settings/Settings';
import EditChallenge from './components/Questions/EditChallenge';
import CoursesHomeScreen from './components/courses/CoursesHomeScreen';
import CoursesMainScreen from './components/courses/CoursesMainScreen';
import PremCatScreen from './components/premium/PremCatScreen';
import PremiumQuiz from './components/premium/PremiumQuiz';
import HyphenSpaceChallenge from './components/premium/HyphenSpaceChallenge';
import UppercaseChallenge from './components/premium/UppercaseChallenge';
import Maps from './components/maps/IdentifyMaps';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Refund from './components/Refund';
import Lottie from 'react-lottie';
import LoginPage from './login/LoginPage';
import Login from './login/Login';
import Logout from './login/Logout';
import Welcome from './components/welcome/Welcome';
import CreateEvents from './components/Questions/CreateEvents';
import CreateClasses from './components/Class/CreateClasses';
import { UserContext } from './components/UserContext';
import AssignmentCategoryMainScreen from './components/assignments/AssignmentCategoryMainScreen';
import AssignmentEventMainScreen from './components/assignments/AssignmentEventMainScreen';
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Subscribe from './components/razorpay_payment/subscription_plan';
import Footer from './components/footer/Footer';
import { isEmpty } from 'lodash';
import ReactGA from 'react-ga4';
import Clarity from './clarity';
import ExpiredSubscriptionPage from './components/razorpay_payment/ExpiredSubscriptionPage';
import TagManager from 'react-gtm-module';
import { default as animationData } from './assets/loader.json';
import { SubscriptionProvider } from './reducers/SubscriptionContext';
import { SubscriptionContext } from './reducers/SubscriptionContext';
import SubscriptionPage from './components/stripe_payment/SubscriptionPage';
import Success from './components/stripe_payment/Success';
import Cancel from './components/stripe_payment/Cancel';
import PremiumDashboard from './components/stripe_payment/PremiumDashboard';
import { LocationContext, LocationProvider } from './reducers/LocationContext';

Amplify.configure(awsconfig);

const tagManagerArgs = {
  gtmId: 'GTM-P3QDZZP'
};

TagManager.initialize(tagManagerArgs);

ReactGA.initialize('G-W38CQYXGCM');

// Define public routes that don't require a subscription
const publicRoutes = [
  '/',
  '/terms',
  '/privacy',
  '/refund',
  '/expired',
  '/login',
  '/logout',
  '/maps',
  '/subscription',
  '/success',
  '/cancel',
  '/settings',
  '/practice',
  '/practicequiz'
];

function ProtectedRoute({ children, ...rest }) {
  const { user } = useContext(UserContext);
  const { subscriptionStatus, loading } = useContext(SubscriptionContext);
  const { countryCode } = useContext(LocationContext);
  const { path } = rest;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (isEmpty(user)) return <LoginPage />;
  if (loading || subscriptionStatus === null) {
    return (
      <div className="welcomecenter">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  // console.log("ProtectedRoute - path:", path, "subscriptionStatus:", subscriptionStatus); // Debug route and status

  // Allow access to public routes regardless of subscription status
  if (publicRoutes.includes(path)) {
    return <Route {...rest} render={() => children} />;
  }

  if (subscriptionStatus === "expired") return <Redirect to="/expired" />;

  if (subscriptionStatus === "active" || subscriptionStatus === 1 || subscriptionStatus === true || subscriptionStatus === "true") {
    return <Route {...rest} render={() => children} />;
  } else {
    if (subscriptionStatus === "none") return <Redirect to="/subscription" />;
  }
}

function ProtectedRouteOnlyLogin({ children, ...rest }) {
  const { user } = useContext(UserContext);
  const { subscriptionStatus, loading } = useContext(SubscriptionContext);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (isEmpty(user)) return <LoginPage />;
  if (loading || subscriptionStatus === null) {
    return (
      <div className="welcomecenter">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  // console.log("ProtectedRouteOnlyLogin - path:", rest.path, "subscriptionStatus:", subscriptionStatus); // Debug route and status

  return <Route {...rest} render={() => children} />;
}

function App() {
  const [user, setUser] = useState({});
  const [score, setScore] = useState({});
  const user_value = useMemo(() => ({ user, setUser }), [user, setUser]);
  const score_value = useMemo(() => ({ score, setScore }), [score, setScore]);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    document.title = 'QuizWhiz';
  }, []);

  return (
    <UserContext.Provider value={user_value}>
      <SubscriptionProvider>
        <LocationProvider>
          {/* <Hotjar /> */}
          <Clarity />
          <BrowserRouter>
            <Navbar />
            <Switch>
              <ProtectedRoute exact path="/openevents">
                <Home />
              </ProtectedRoute>
              <Route exact path="/" component={Welcome} />
              <Route exact path="/terms" component={Terms} />
              <Route exact path="/privacy" component={Privacy} />
              <Route exact path="/refund" component={Refund} />
              <Route exact path="/expired" component={ExpiredSubscriptionPage} />
              <ProtectedRoute exact path="/events">
                <EventMainScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/opencourses">
                <CoursesHomeScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/courses">
                <CoursesMainScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/quiz">
                <QuizScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/coursequiz">
                <CourseQuizScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/quiz1">
                <QuizScreen1 />
              </ProtectedRoute>
              <ProtectedRoute exact path="/assignments">
                <AssignmentCategoryMainScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/editchallenge">
                <EditChallenge />
              </ProtectedRoute>
              <ProtectedRoute exact path="/assignmentevents">
                <AssignmentEventMainScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/questions">
                <CreateEvents />
              </ProtectedRoute>
              <ProtectedRoute exact path="/batch">
                <CreateClasses />
              </ProtectedRoute>
              <Route exact path="/login" component={LoginPage} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/maps" component={Maps} />
              <ProtectedRouteOnlyLogin exact path="/subscribe">
                <Subscribe />
              </ProtectedRouteOnlyLogin>
              <ProtectedRouteOnlyLogin exact path="/subscription">
                <SubscriptionPage />
              </ProtectedRouteOnlyLogin>
              <ProtectedRouteOnlyLogin exact path="/success">
                <Success />
              </ProtectedRouteOnlyLogin>
              <ProtectedRouteOnlyLogin exact path="/cancel">
                <Cancel />
              </ProtectedRouteOnlyLogin>
              {/* <ProtectedRoute > */}
                <PremiumDashboard exact path="/premiumdashboard"/>
              {/* </ProtectedRoute> */}
              <ProtectedRoute exact path="/texttospeech">
                <TexttoSpeech />
              </ProtectedRoute>
              <ProtectedRoute exact path="/editbatch">
                <EditBatch />
              </ProtectedRoute>
              <ProtectedRoute exact path="/dashboard">
                <Dashboard />
              </ProtectedRoute>
              <ProtectedRoute exact path="/editevents">
                <EditNewQuestions1 />
              </ProtectedRoute>
              <ProtectedRouteOnlyLogin exact path="/dailyreview">
                <DailyReviewScreen />
              </ProtectedRouteOnlyLogin>
              <ProtectedRouteOnlyLogin exact path="/practiceevents">
                <PracticeCatScreen />
              </ProtectedRouteOnlyLogin>
              <Route exact path="/practice" component={PracticeScreen} />
              <Route exact path="/practicequiz" component={PracticeQuiz} />
              <Route exact path="/practice-subcategory" component={SubCategorySelection} />
              <ProtectedRouteOnlyLogin exact path="/settings">
                <Settings />
              </ProtectedRouteOnlyLogin>
              <ProtectedRoute exact path="/premiumevents">
                <PremCatScreen />
              </ProtectedRoute>
              <ProtectedRoute exact path="/premiumquiz">
                <PremiumQuiz />
              </ProtectedRoute>
              <ProtectedRoute exact path="/hyphen-space-challenge">
                <HyphenSpaceChallenge />
              </ProtectedRoute>
              <ProtectedRoute exact path="/uppercase-challenge">
                <UppercaseChallenge />
              </ProtectedRoute>
            </Switch>
            <Footer />
          </BrowserRouter>
        </LocationProvider>
      </SubscriptionProvider>
    </UserContext.Provider>
  );
}

export default App;